// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2AvqX","row":"Node_row__N_BsF","label":"Node_label__2s-ho","footer":"Node_footer__td9lE"};